var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageCopyNNoStrokeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5192 6.23844V9.11844C11.5192 9.64863 11.949 10.0784 12.4792 10.0784H15.3592M17.2792 2.39844H10.559C9.4986 2.39844 8.63899 3.25805 8.63898 4.31843V6.23844M17.2792 2.39844H17.8148C18.0851 2.39844 18.3424 2.51231 18.5287 2.70826C18.8086 3.00274 19.2519 3.45615 19.6792 3.83844C20.0141 4.13805 20.5402 4.67575 20.8552 5.00254C21.0256 5.17927 21.1192 5.41523 21.1192 5.6607L21.1192 6.23844M17.2792 2.39844V5.27844C17.2792 5.80863 17.709 6.23844 18.2392 6.23844H21.1192M21.1192 6.23844L21.1189 15.8385C21.1189 16.8989 20.2593 17.7584 19.1989 17.7584H15.3589M13.9192 7.67844C13.4919 7.29615 13.0486 6.84274 12.7687 6.54826C12.5824 6.35231 12.3251 6.23844 12.0548 6.23844H4.79898C3.7386 6.23844 2.87899 7.09805 2.87898 8.15843L2.87891 19.6784C2.8789 20.7388 3.73851 21.5984 4.7989 21.5984L13.4389 21.5984C14.4993 21.5984 15.3589 20.7389 15.3589 19.6785L15.3592 9.5007C15.3592 9.25523 15.2656 9.01927 15.0952 8.84255C14.7802 8.51576 14.2541 7.97805 13.9192 7.67844Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCopyNNoStrokeColor);
export default __webpack_public_path__ + "static/media/ManageCopyN_NoStrokeColor.7b75f105f5d5a8f55a134fbc122a6415.svg";
export { ForwardRef as ReactComponent };